import { useCallback } from 'react';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useNow } from '@/hooks/use-now';
import { useGetPathwaysQuery, useDeletePathwayMutation } from '@/api/pathways';
import { useGetInventoryQuery } from '@/api/inventories';
import { Loading } from '@/components/loading';
import { Layout } from '@/components/layout';
import { PathwaysList } from '@/components/pathways-list';

// The Pathway product's list page (on ledger). The synthetic "Legacy
// pathways" entry is gated on the inventory detail's legacyPathwaysExist
// signal — existing users keep access to their current legacy pathways
// while the re-platform settles.
const Pathways = () => {
  const inventoryId = useInventoryId();
  const now = useNow();
  const { data: pathways, isLoading } = useGetPathwaysQuery(inventoryId);
  const { data: inventory } = useGetInventoryQuery(inventoryId);
  const [deletePathway] = useDeletePathwayMutation();
  const onDelete = useCallback(
    (pathwayId: number) => {
      deletePathway({ pathwayId });
    },
    [deletePathway],
  );

  if (isLoading) {
    return <Loading />;
  }
  return (
    <Layout>
      <PathwaysList
        now={now}
        pathways={pathways ?? []}
        inventoryId={inventoryId}
        legacyPathwaysExist={inventory?.legacyPathwaysExist ?? false}
        onDelete={onDelete}
      />
    </Layout>
  );
};

export { Pathways };
